import { FC, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import ROUTES from '../../library/constants/routeConstants';
import { useAppSelector } from '../hooks/hooks';
import Layout from '../layout/Layout';
import { selectIsUserLoggedIn } from '../slices/authSlice';

interface PrivateRouteTypes {
    renderApp: boolean,
    children: JSX.Element,
    canAccessRoute: boolean
};

const contentFallback = (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress size={36} />
    </Box>
);

const PrivateRoute: FC<PrivateRouteTypes> = ({renderApp, children, canAccessRoute}) => {
    const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
    const location = useLocation();

    if (!isLoggedIn) {
        return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace={true} />;
    }
    if (!canAccessRoute) {
        return <Navigate to={ROUTES.DASHBOARD} replace={true} />;
    }
    return (
        <Layout>
            <Suspense fallback={contentFallback}>
                {children}
            </Suspense>
        </Layout>
    );
};

export default PrivateRoute;
